module.exports = __webpack_public_path__ + "img/midnightsons.64f0945b.svg";